import { Selector } from "./selector"
export * from "./selector"
export const PricingTableSelector = Selector



// WEBPACK FOOTER //
// ./src/state/pricing/selectors/index.ts